import { render } from "./DiveTag.vue?vue&type=template&id=749cefc0&scoped=true"
import script from "./DiveTag.vue?vue&type=script&lang=js"
export * from "./DiveTag.vue?vue&type=script&lang=js"

import "./DiveTag.vue?vue&type=style&index=0&id=749cefc0&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749cefc0"]])

export default __exports__